/**
 * Captcha Component
 */
export class Captcha {
    constructor() {
        // 기존 initCaptcha 로직 유지
        if (typeof initCaptcha === 'function') {
            initCaptcha();
        }
    }
}

